<template>
    <Modal v-model:visible="visible" :backdrop="true">
        <template v-slot:header>
            <div>
                <h2 class="text-2xl font-bold">Filtri avanzati</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="grid grid-cols-4 mb-2 gap-2 mt-3">
                <div class="col-span-2 flex flex-col" v-show="anno != null">
                    <Field :modelValue="anno"
                           @update:modelValue="$emit('update:anno', $event)"
                           field_name="Anno"
                           placeholder="Anno"

                    ></Field>
                    <!--                           :input-attrs="{-->
                    <!--                               type:'number',-->
                    <!--                               value: ''-->
                    <!--                           }"-->
                </div>

                <div class="col-span-2 flex flex-col" v-show="bu != null">
                    <Field field_name="Business unit">
                        <VueMultiselect
                            v-model="buAutocomplete.selection"
                            :options="buAutocomplete.options"
                            placeholder="Business unit"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="nome"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            :close-on-select="false"
                            :clear-on-select="true"
                            @search-change="buAutocomplete.search"
                        >
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.nome }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Inizio dal"
                           type="date"
                           :modelValue="data_inizio_dal"
                           @update:modelValue="$emit('update:data_inizio_dal', $event)">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Inizio al"
                           type="date"
                           :modelValue="data_inizio_al"
                           @update:modelValue="$emit('update:data_inizio_al', $event)">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Fine dal"
                           type="date"
                           :modelValue="data_fine_dal"
                           @update:modelValue="$emit('update:data_fine_dal', $event)">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Fine al"
                           type="date"
                           :modelValue="data_fine_al"
                           @update:modelValue="$emit('update:data_fine_al', $event)">
                    </Field>
                </div>
                <div class="col-span-4 flex flex-col w-full">
                    <Field field_name="Cliente/committente"
                           placeholder="Cliente/committente">
                        <VueMultiselect @search-change="clienteAutocomplete.search"
                                        :loading="clienteAutocomplete.isLoading"
                                        :options="clienteAutocomplete.options"
                                        v-model="clienteAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="col-span-2 flex flex-col w-full" v-show="azienda_gruppo != null">
                    <Field field_name="Azieda del gruppo"
                           placeholder="Azieda del gruppo">
                        <VueMultiselect @search-change="aziendaGruppoAutocomplete.search"
                                        :loading="aziendaGruppoAutocomplete.isLoading"
                                        :options="aziendaGruppoAutocomplete.options"
                                        v-model="aziendaGruppoAutocomplete.selection"
                                        track-by="id" label="nome"
                                        class="next-vue-multiselect-single"
                                        placeholder="Azienda del gruppo"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="col-span-2 flex flex-col" v-show="stato != null">
                    <Field field_name="Stato">
                        <VueMultiselect
                            v-model="statoAutocomplete.selection"
                            :options="statoAutocomplete.options"
                            placeholder="Stato"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="descrizione"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="true"
                            :close-on-select="true"
                            :clear-on-select="true"
                            @search-change="statoAutocomplete.search"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="col-span-2 flex flex-col" v-if="accounts != null">
                    <Field field_name="Account">
                        <VueMultiselect :searchable="true" :loading="accountsAutocomplete.isLoading"
                                        :internal-search="false"
                                        trackBy="id"
                                        label="nome"
                                        @search-change="accountsAutocomplete.search"
                                        v-model="accountsAutocomplete.selection"
                                        :options="accountsAutocomplete.options"
                                        :multiple="true"
                                        :close-on-select="true" :clear-on-select="true" class="next-vue-multiselect"
                                        placeholder="Account"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                        >
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:noOptions>Digita per cercare</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="col-span-2 flex flex-col" v-if="pm != null">
                    <Field field_name="PM">
                        <VueMultiselect :searchable="true" :loading="pmAutocomplete.isLoading"
                                        :internal-search="false"
                                        trackBy="id"
                                        label="nome"
                                        @search-change="pmAutocomplete.search"
                                        v-model="pmAutocomplete.selection"
                                        :options="pmAutocomplete.options"
                                        :multiple="true"
                                        :close-on-select="true" :clear-on-select="true" class="next-vue-multiselect"
                                        placeholder="PM"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                        >
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:noOptions>Digita per cercare</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                        <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                            {{ option.bu_label || '&nbsp;' }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                                <span>
                                    <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                    <span class="ml-2">{{ option.name }}</span>
                                </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>


                <div class="col-span-2 flex flex-col" v-if="direttori != null">
                    <Field field_name="Produzione">
                        <VueMultiselect v-model="direttoriAutocomplete.selection"
                                        :options="direttoriAutocomplete.options"
                                        :multiple="true"
                                        @search-change="direttoriAutocomplete.search"
                                        :close-on-select="true"
                                        placeholder="Produzione"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect"
                                        track-by="id"
                                        label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:noOptions>Digita per cercare</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                        <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                            {{ option.bu_label || '&nbsp;' }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                                <span>
                                    <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                    <span class="ml-2">{{ option.name }}</span>
                                </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>


            </div>
        </template>
        <template v-slot:footer>
            <div class="flex items-end justify-end gap-3">
                <NextButton variant="primary"
                            @click="$emit('update:visible', false)"
                            class="px-4 h-10">
                    Applica
                </NextButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, setup} from 'vue-class-component';
import {Vue} from 'vue-class-component';
import Field from "@/components/Field.vue";
import Autocomplete from "@/setup/Autocomplete";
import clientiManager from "../api/Clienti";
import Modal from "@/components/Modal.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import SelectStato from "@/components/SelectStato.vue";
import businessUnitsManager from "../api/BusinessUnits";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import NextButton from "@/components/NextButton.vue";
import statoManager from "../api/Stato";
import {aziendeGruppoManager} from "../api/AziendeGruppo";
import userManager from "../api/Users";


@Options({
    name: 'ModalProjectFilter',
    components: {
        NextButton,
        SelectStato,
        MultiselectOption,
        Field,
        Modal
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        anno: [Number, String],
        data_inizio_dal: String,
        data_inizio_al: String,
        data_fine_dal: String,
        data_fine_al: String,
        cliente: [Number, String],
        azienda_gruppo: [Number, String],
        bu: [Number, String],
        stato: [Number, String],
        progetti: Boolean,
        accounts: Array,
        direttori: Array,
        pm: Array,
    },
    emits: ['update:anno',
        'update:data_inizio_dal',
        'update:data_inizio_al',
        'update:data_fine_dal',
        'update:data_fine_al',
        'update:cliente',
        'update:azienda_gruppo',
        'update:bu',
        'update:stato',
        'update:visible',
        'update:accounts',
        'update:direttori',
        'update:pm'
    ]
})

export default class ModalProjectFilter extends Vue {
    variant!: string
    progetti!: boolean
    component!: string
    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager))
    statoAutocomplete: any = setup(() => Autocomplete(statoManager))
    aziendaGruppoAutocomplete: any = setup(() => Autocomplete(aziendeGruppoManager))

    accountsAutocomplete: any = setup(() => Autocomplete(userManager, true))
    direttoriAutocomplete: any = setup(() => Autocomplete(userManager, true))
    pmAutocomplete: any = setup(() => Autocomplete(userManager, true))

    @Watch('clienteAutocomplete.selection')
    @Watch('buAutocomplete.selection')
    @Watch('statoAutocomplete.selection')
    @Watch('aziendaGruppoAutocomplete.selection')
    @Watch('accountsAutocomplete.selection')
    @Watch('direttoriAutocomplete.selection')
    @Watch('pmAutocomplete.selection')
    selectWatch(new_value: any, old: any) {
        this.$emit('update:cliente', this.clienteAutocomplete.selection?.id || '')
        this.$emit('update:bu', this.buAutocomplete.selection?.id || '')
        this.$emit('update:stato', this.statoAutocomplete.selection?.PD1E_CODICE || '')
        this.$emit('update:azienda_gruppo', this.aziendaGruppoAutocomplete.selection?.id || '')
        this.$emit('update:accounts', this.accountsAutocomplete.selection ? this.accountsAutocomplete.selection.map((e: any) => e.id) : [])
        this.$emit('update:direttori', this.direttoriAutocomplete.selection ? this.direttoriAutocomplete.selection.map((e: any) => e.id) : [])
        this.$emit('update:pm', this.pmAutocomplete.selection ? this.pmAutocomplete.selection.map((e: any) => e.id) : [])
    }

    @Watch('$props.cliente', {deep: true})
    emptyClienteSelect(new_value: any, old: any) {
        if (new_value == '') {
            this.clienteAutocomplete.selection = null
        }
    }

    @Watch('$props.stato', {deep: true})
    emptyStatoSelect(new_value: any, old: any) {
        if (new_value == '') {
            this.statoAutocomplete.selection = null
        }
    }

    @Watch('$props.bu', {deep: true})
    emptyBuSelect(new_value: any, old: any) {
        if (new_value == '') {
            this.buAutocomplete.selection = null
        }
    }

    @Watch('$props.azienda_gruppo', {deep: true})
    emptyAziendaGruppoSelect(new_value: any, old: any) {
        if (new_value == '') {
            this.aziendaGruppoAutocomplete.selection = null
        }
    }

    @Watch('$props.accounts', {deep:true})
    emptyAccountsSelect(new_value: any, old: any) {
        if (!new_value.length) {
            this.accountsAutocomplete.selection = null
        }
    }
    @Watch('$props.direttori', {deep:true})
    emptyDirettoriSelect(new_value: any, old: any) {
        if (!new_value.length) {
            this.direttoriAutocomplete.selection = null
        }
    }

    @Watch('$props.pm', {deep:true})
    emptyPmSelect(new_value: any, old: any) {
        if (!new_value.length) {
            this.pmAutocomplete.selection = null
        }
    }

    created() {
        if (this.progetti) {
            this.statoAutocomplete.addAjaxParam('p', 1)
        }

        this.clienteAutocomplete.search('', 0)
        this.buAutocomplete.search('', 0)
        this.statoAutocomplete.search('', 0)
        this.aziendaGruppoAutocomplete.search('', 0)
        this.accountsAutocomplete.search('', 0)
        this.direttoriAutocomplete.search('', 0)
        this.pmAutocomplete.search('', 0)
    }


    empty() {
        this.$emit('update:data_inizio_dal', '')
        this.$emit('update:data_inizio_al', '')
        this.$emit('update:data_fine_dal', '')
        this.$emit('update:data_fine_al', '')
        this.$emit('update:cliente', '')
        this.$emit('update:azienda_gruppo', '')
        this.$emit('update:bu', '')
        this.$emit('update:stato', '')
        this.$emit('update:accounts', [])
        this.$emit('update:direttori', [])
        this.$emit('update:pm', [])
    }
}
</script>
